/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Script from 'next/script';
import Style from './RastreadoresBannerV2.css';

function RastreadoresBannerV2() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="rastreadores-banner">
        <div className="ctn">
          <div className="text-container">
            <h1 className="text-title">Rastreadores</h1>
            <p className="text-description">
              Mais segurança e garantia de uma forma simples e rápida!
            </p>
          </div>
          <div className="img-container">
            <h1>
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width <= 600 && (
                    <img
                      src="assets/rastreadores/banner/banner-v3-mb.png"
                      alt=""
                      className="img-600"
                    />
                  )}
                  {width > 600 && width <= 992 && (
                    <img
                      src="assets/rastreadores/banner/banner-v3.png"
                      alt=""
                      className="img-992 rp"
                    />
                  )}
                  {width > 992 && width <= 1320 && (
                    <img
                      src="assets/rastreadores/banner/banner-v3.png"
                      alt=""
                      className="img-1320"
                    />
                  )}
                  {width > 1320 && (
                    <img
                      src="assets/rastreadores/banner/banner-v3.png"
                      alt=""
                      className="img-2650"
                    />
                  )}
                </>
              )}
            </h1>
          </div>
        </div>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default RastreadoresBannerV2;
